// Mirrors Stevie.Cloud.Api.vNext.Models.FileExtension (ADR 004).
// Enum serialised as string on the wire per JsonStringEnumConverter on the backend.
export enum FileExtension {
  Json = 'Json',
  Csv = 'Csv',
}
